import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Higher-order component to guard routes/components by role
// Usage: export default withRoleGuard(['student'])(Component)
const withRoleGuard = (allowedRoles = []) => (WrappedComponent) => {
  const Guard = (props) => {
    const { user, token, initializing, isRefreshing } = useAuth();
    const location = useLocation();

    // The stored session is restored asynchronously. Bouncing to /login while
    // that happens is what forced a fresh login in every newly opened tab.
    if (initializing || isRefreshing) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
        </div>
      );
    }

    if (!token || !user) {
      return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
      return <Navigate to="/dashboard" replace />;
    }

    return <WrappedComponent {...props} />;
  };

  return Guard;
};

export default withRoleGuard;
